import React from 'react'


const CardViewSortition = ({ setSortText, columns, hasSorting, options }) => {
    const [sortList, setSortList] = React.useState([]);
    const [isOpenSort, setIsOpenSort] = React.useState(false)

   

    const handleCardSortClick = (e, col) => {
        const list = clickCardSortItem(e, col, sortList);
        setSortList([...list])
        setSortText({ sortText: createSortText(list) })

    }

    const getSortItem = (col) => {
        const selectedItemIdx = sortList.length > 0 ?
            sortList.map(item => item.property).indexOf(col.property) : -1
        if (selectedItemIdx > -1) {
            return { type: sortList[selectedItemIdx].type, index: selectedItemIdx }
        }
        return false
    }

    const selectSortTypeItem = (col, type) => {
        let tempList = sortList;
        tempList.map(item => {
            if (item.property === col.property) {
                item.type = type
            }
        })
        setSortList([...tempList])
        setSortText({ sortText: createSortText(tempList) })
    }

    return (
        <>
         
            <div className='card-view-sort-context' >
               {hasSorting && <div onClick={()=>setIsOpenSort(!isOpenSort)} >{isOpenSort ?<CloseSettingSvg/> :<SettingSvg />} </div>}
                <div className={isOpenSort ? 'open-sort sort-options':'sort-options'}>
                    <ul>
                        {columns.map((column, idx) => {
                            const colState = getSortItem(column)
                            return (<li key={idx} >

                                {hasSorting && column.hasSort ?
                                    <span onClick={(e) => handleCardSortClick(e, column)}>
                                        {column.title}
                                        <span
                                            className={sortList.some(item => item.property === column.property) ?
                                                'open sort-displayer' : 'sort-displayer'}>
                                            <span>
                                                <span onClick={(e) => { e.stopPropagation(); selectSortTypeItem(column, "ASC") }}>ASC {colState && colState.type === "ASC" ? <CheckSvg /> : <UncheckSvg />}</span>
                                                <span onClick={(e) => { e.stopPropagation(); selectSortTypeItem(column, "DES") }} >DES {colState && colState.type === "DES" ? <CheckSvg /> : <UncheckSvg />}</span>
                                            </span>

                                        </span>
                                    </span> : <span>{column.title}</span>}
                            </li>)
                        })}
                    </ul>
                </div>
            </div>
        </>

    )
}

export default CardViewSortition

const createSortText = (list) => {
    let str = "";
    list.map((item, idx) => {
        if (idx === 0) {
            str += `${item.property} ${item.type}`
        } else {
            str += `,${item.property} ${item.type}`

        }
    })
    return str;
}




const clickCardSortItem = (e, col, list) => {
    let tempList = list;

    if (tempList.some(item => item.property === col.property)) {
        tempList = tempList.filter(item => item.property !== col.property)
    } else {
        tempList.push({ property: col.property, type: "ASC" })
    }
    return tempList;


}

export const UncheckSvg = ({ width = 24, height = 24, fill , styles }) => {
    return (
        <svg  style={{ ...styles, width, height, verticalAlign: "middle" }} viewBox="0 0 24 24">
        <path d="M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M19,5V19H5V5H19Z" />
    </svg>
    );
};

export const SettingSvg = ({ width = 24, height = 24, fill , styles }) => {
    return (
        <svg style={{ ...styles, width, height, verticalAlign: "middle" }}  viewBox="0 0 24 24">
    <path  d="M12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5M19.43,12.97C19.47,12.65 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.66 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.21,8.95 2.27,9.22 2.46,9.37L4.57,11C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.21,15.05 2.34,15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.5,18.67 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.97Z" />
</svg>
    );
};

export const CloseSettingSvg = ({ width = 24, height = 24, fill , styles }) => {
    return (
        <svg style={{ ...styles, width, height, verticalAlign: "middle" }}  viewBox="0 0 24 24">
    <path  d="M22.12 21.46L2.4 1.73L1.12 3L4 5.87L2.34 8.73C2.21 8.95 2.27 9.22 2.46 9.37L4.57 11C4.53 11.34 4.5 11.67 4.5 12S4.53 12.65 4.57 12.97L2.46 14.63C2.27 14.78 2.21 15.05 2.34 15.27L4.34 18.73C4.46 18.95 4.73 19.03 4.95 18.95L7.44 17.94C7.96 18.34 8.5 18.68 9.13 18.93L9.5 21.58C9.54 21.82 9.75 22 10 22H14C14.25 22 14.46 21.82 14.5 21.58L14.87 18.93C15.38 18.72 15.83 18.45 16.26 18.14L20.85 22.73L22.12 21.46M12 15.5C10.07 15.5 8.5 13.93 8.5 12C8.5 11.5 8.62 11.08 8.79 10.67L13.33 15.21C12.92 15.39 12.5 15.5 12 15.5M11.74 8.53L8.56 5.35C8.75 5.25 8.93 5.15 9.13 5.07L9.5 2.42C9.54 2.18 9.75 2 10 2H14C14.25 2 14.46 2.18 14.5 2.42L14.87 5.07C15.5 5.32 16.04 5.66 16.56 6.05L19.05 5.05C19.27 4.96 19.54 5.05 19.66 5.27L21.66 8.73C21.78 8.95 21.73 9.22 21.54 9.37L19.43 11C19.47 11.34 19.5 11.67 19.5 12S19.47 12.65 19.43 12.97L21.54 14.63C21.73 14.78 21.78 15.05 21.66 15.27L20.5 17.29L15.47 12.26C15.5 12.18 15.5 12.09 15.5 12C15.5 10.07 13.93 8.5 12 8.5C11.91 8.5 11.83 8.5 11.74 8.53Z" />
</svg>
    );
};

export const CheckSvg = ({ width = 24, height = 24, fill , styles }) => {
    return (
        <svg   style={{ ...styles, width, height, verticalAlign: "middle" }}  viewBox="0 0 24 24">
        <path  d="M10,17L5,12L6.41,10.58L10,14.17L17.59,6.58L19,8M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z" />
    </svg>
    );
};
export const ArrowUp = ({ width = 24, height = 24, fill, styles }) => {
    return (
        <svg  style={{ ...styles, width, height, verticalAlign: "middle" }} viewBox="0 0 24 24">
    <path   d="M7.03 9.97H11.03V18.89L13.04 18.92V9.97H17.03L12.03 4.97Z" />
</svg>
    );
};
export const ArrowDown = ({ width = 24, height = 24, fill, styles }) => {
    return (
        <svg  style={{ ...styles, width, height, verticalAlign: "middle" }} viewBox="0 0 24 24">
    <path  d="M7.03 13.92H11.03V5L13.04 4.97V13.92H17.03L12.03 18.92Z" />
</svg>
    );
};